import { Component, inject } from "@angular/core";
import { AppState } from "../../services/app-state";

@Component({
    selector: "canvas-spinner",
    imports: [],
    templateUrl: "./spinner.html",
    styleUrl: "./spinner.scss",
})
export class Spinner {
    private spinnerState = inject(AppState);

    readonly isLoading = this.spinnerState.isLoading;
}
